import { render } from "./NouveauPatient.vue?vue&type=template&id=8bacebf4"
import script from "./NouveauPatient.vue?vue&type=script&lang=js"
export * from "./NouveauPatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__